import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneListItem = _resolveComponent("SceneListItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock(_component_ElScrollbar, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createBlock(_component_SceneListItem, {
          key: `scene-item-${index}-${item.objectName}`,
          item: item,
          onEdit: ($event: any) => (_ctx.handleAction('edit', item)),
          onRemove: ($event: any) => (_ctx.handleAction('remove', item))
        }, null, 8, ["item", "onEdit", "onRemove"]))
      }), 128))
    ]),
    _: 1
  }))
}